import React, {useState} from "react";
import GenericDialog from "../../../ui/dialogs/generic-dialog/GenericDialog";
import Typography from "@material-ui/core/Typography";
import PremiumNotification from "../../../ui/notifications/premium-notification/PremiumNotification";
import {ReactComponent as PremiumIcon} from '../../../../assets/images/icon-big-premium-88-px.svg';
import {useSelector} from "react-redux";
import ContattaciCards from "../../../../shared/components/cards/contattaci-cards/ContattaciCards";
import PremiumDialog from "../../../mobile/sub-menu-items/richieste-assistenza/Dialogs/PremiumDialog/PremiumDialog";
import PropTypes from "prop-types";

const ContattaciDialog = (props) => {
    const [premiumDetailsModal, setPremiumDetailsModal] = useState(false)
    const selectedCompany = useSelector((state) => state.authReducer.selectedCompany)

    const openPremiumModal = () => setPremiumDetailsModal(!premiumDetailsModal)

    const handleDialogClose = () => {
        props.handleDialogClose();
    }

    const handleContattaciCloseButton = () => {
        props.handleContattaciCloseButton();
    }

    const dialogContent = (
        <React.Fragment>
            {selectedCompany.livelloDiAssistenzaId !== 1 ? <PremiumNotification buttonText={"Scopri"}
                                                                                onClick={() => openPremiumModal()}
                                                                                icon={<PremiumIcon/>}
                                                                                title={"Assistenza Premium"}
                                                                                message={"Questo contratto prevede livello di assistenza PREMIUM con linea telefonica dedicata e SLA preferenziali"}/> : null}
            <ContattaciCards/>
            {premiumDetailsModal ? <PremiumDialog open={premiumDetailsModal} close={openPremiumModal}/> : null}
        </React.Fragment>
    );

    const dialogActions = <React.Fragment />;

    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={handleDialogClose}
            handleDialogCloseButton={handleContattaciCloseButton}
            dialogActions={dialogActions}
            dialogContent={dialogContent}
        >
            <Typography variant={"h5"}>Contattaci</Typography>
        </GenericDialog>
    );
};

ContattaciDialog.propTypes = {
    handleDialogClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    handleContattaciCloseButton: PropTypes.func.isRequired
}

export default ContattaciDialog
